import { cloneElement, FC, isValidElement, ReactElement, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { messages } from '../../i18n';
import { useWorkspaceMenu } from './useWorkspaceMenu';
import { CustomMobileMenu } from './CustomDropdownMenu/CustomeMobileMenu';
import { WorkspaceMenuHookPropMobile } from './WorkspaceMenu.types';

export const WorkspaceMenuMobile: FC<WorkspaceMenuHookPropMobile> = ({
  trigger,
  items,
  footerItem,
  defaultSelectedId,
  onSelect,
  onSearchTermChange,
  showSearch,
  onOpenChange,
}) => {
  const { formatMessage } = useIntl();

  const {
    footer,
    searchBar,
    onOpenChange: onOpen,
    selectedId,
    setSelectedId,
  } = useWorkspaceMenu({
    items,
    footerItem,
    showSearch,
    defaultSelectedId,
    onSearchTermChange,
    onSelect,
  });

  const [isOpen, setIsOpen] = useState(false);

  const toggleOpenState = useCallback(() => {
    setIsOpen((isOpen) => !isOpen);
    onOpen(!isOpen);
    onOpenChange?.(!isOpen);
  }, [setIsOpen, isOpen, onOpenChange, onOpen]);

  const onSelectCallback = useCallback(
    // TODO: Provide explicit types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (id: any) => {
      setSelectedId?.(id);
      toggleOpenState();
    },
    [setSelectedId, toggleOpenState]
  );

  return (
    <>
      {isValidElement(trigger) && cloneElement(trigger as ReactElement, { onClick: toggleOpenState })}
      {isOpen && (
        <CustomMobileMenu
          isOpened
          backdropClickHandler={toggleOpenState}
          headerTitle={formatMessage(messages.workspaceMenuMobileHeader)}
          onSelect={onSelectCallback}
          selectedId={selectedId}
          trigger={trigger}
          searchBar={searchBar}
          footer={footer}
          items={items}
        />
      )}
    </>
  );
};
